package ai.flowstorm.studio.ui.data

import ai.flowstorm.studio.model.Initiation
import ai.flowstorm.studio.model.Space
import ai.flowstorm.studio.resources.space.ApplicationResource
import ai.flowstorm.studio.resources.space.InitiationResource
import ai.flowstorm.studio.resources.space.UserAssignmentResource
import ai.flowstorm.common.model.idPair
import kotlinx.coroutines.launch
import ai.flowstorm.common.ui.EntityForm
import ai.flowstorm.common.ui.UiHelpers
import ai.flowstorm.common.ui.form.ListIdSelect
import ai.flowstorm.common.ui.form.SelectId
import io.kvision.core.PosFloat
import io.kvision.form.select.Select
import io.kvision.form.spinner.SimpleSpinner
import io.kvision.form.text.Text
import io.kvision.html.button
import io.kvision.i18n.I18n
import io.kvision.i18n.tr
import io.kvision.panel.simplePanel
import io.kvision.utils.px

class InitiationForm : EntityForm<Initiation>(InitiationResource) {
    init {
        add(
                Initiation::name,
                Text(label = tr("Name")),
                required = true,
                requiredMessage = tr("Required field")
        )
        add(
                Initiation::deviceType,
                Select(label = tr("Device Type"), options = UiHelpers.options(arrayOf(/*"Any", */"Phone", "Standalone", "Mobile", "Web")), value = "Any"),
                required = true,
                requiredMessage = tr("Required field")
        )
        add(
                Initiation::application_id,
                SelectId(label = tr("Application")).apply {
                    mainScope.launch {
                        options = UiHelpers.options(ApplicationResource)
                    }
                },
                required = true,
                requiredMessage = tr("Required field")
        )
        add(
                Initiation::users_id,
                ListIdSelect(label = tr("Users")).apply {
                    mainScope.launch {
                        options = UiHelpers.options(UserAssignmentResource) { e:Space.UserAssignment -> e._user?.idPair() }
                    }
                },
                required = true,
                requiredMessage = tr("Required field")
        )
        add(
                Initiation::coreUrl,
                Text(label = tr("Custom Core URL"))
        )
        add(
                Initiation::repeats,
                SimpleSpinner(label = I18n.tr("Repeats"), min = 1, max = 100, step = 1)
        )
        simplePanel {
            float = PosFloat.RIGHT
            button(tr("Rerun")).onClick {
                mainScope.launch {
                    InitiationResource.rerun(entity!!.id)
                }
            }.marginLeft = 10.px
        }
    }
}